<template>
  <div class="h-100">
    <b-container fluid="" class="px-0">
      <miu-header
        :page-title="streamInfo ? streamInfo.title : ''"
        :back-button="currentPage > 1"
        close-button
        @back="backButtonHeader"
        @close="backToStream"
      />
    </b-container>
    <div class="max-width container-fluid h-100">
      <transition name="fade" mode="out-in">
        <div class="row h-100" :key="blockId ? blockId : 'extra'">
          <div class="col-md-8 offset-md-2 d-flex align-items-center h-100 position-inherit pt-3">
            <slot v-if="showExtraPage" name="extra-block" />
            <template v-else>
              <highlightable>
                <stream-block-container
                  v-for="block in blocks(currentPage)"
                  :key="block.id"
                  :block="block"
                  :user-id="Number(userId)"
                  classes="single-stream-block"
                />
              </highlightable>
            </template>
          </div>
        </div>
      </transition>
    </div>

    <div class="w-100 fixed-bottom index pb-3 pb-lg-4 bg-white">
      <div class="max-width container-fluid h-100">
        <div class="row no-gutters">
          <div class="col-md-4 offset-md-2 border-top d-none d-md-block">
            <b-button
              v-if="currentPage > 1"
              variant="link"
              class="mt-2 mt-lg-3"
              :size="sizeButton"
              @click="backButtonFooter"
              role="button"
            >
              {{ trans("streams.back") }}
            </b-button>
          </div>

          <div class="col-md-4 border-top text-right">
            <b-button
              v-if="currentPage < numPages"
              variant="secondary"
              class="mt-2 mt-lg-3"
              :size="sizeButton"
              @click="continueClick"
            >
              {{ trans("streams.continue") }}
            </b-button>
            <loading-button
              v-else
              :loading="nextLoading"
              variant="secondary"
              :button-text="trans('streams.continue')"
              button-class="mt-2 mt-lg-3"
              :size="sizeButton"
              @click="$emit('onPagesCompleted')"
            />
          </div>
        </div>
      </div>
      <div class="w-100 progress-bar">
        <page-progress v-if="!isLoading" :current="currentPage" :max="numPages" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import MiuHeader from "../MiuHeader";
import StreamBlockContainer from "../StreamBlockContainer";
import navMixin from "../../mixins/navMixin";
import mobileCheckMixin from "../../mixins/mobileCheckMixin";
import streamMixin from "../../mixins/streamMixin";
import LoadingButton from "../../atoms/LoadingButton";
import PageProgress from "../../molecules/PageProgress";
import Highlightable from "../../molecules/Highlightable";

export default {
  components: { LoadingButton, MiuHeader, StreamBlockContainer, PageProgress, Highlightable },
  name: "StreamMiuPageContainer",
  props: {
    nextLoading: {
      type: Boolean,
      required: true,
    },
    existExtraBlock: Boolean,
  },
  mounted() {
    this.setCurrentPage(this.$route.query.page ? Number(this.$route.query.page) : 1);
  },
  methods: {
    ...mapMutations({
      setCurrentPage: "streams/setCurrentPage",
      setBlocksPerPage: "streams/setBlocksPerPage",
    }),
    backButtonHeader() {
      this.backPreviousBlock();
      trackEvent("StreamElementBack", this.parsTracking);
    },
    backButtonFooter() {
      this.backPreviousBlock();
      trackEvent("StreamElementFooterBack", this.parsTracking);
    },
    backPreviousBlock() {
      this.setCurrentPage(this.currentPage - 1);
    },
    backToStream() {
      trackEvent("StreamElementClose", this.parsTracking);
      this.$emit("backToStream");
    },
    updateRoute(page) {
      this.$router.push(`?page=${page}`).catch((err) => {});
    },
    continueClick() {
      if (!this.isLastPage) {
        this.setCurrentPage(this.currentPage + 1);
        trackEvent("StreamElementNext", this.parsTracking);
      } else {
        this.$emit("onPagesCompleted");
      }
    },
  },
  computed: {
    ...mapGetters({
      blocks: "streams/getPageBlocks",
      isLoading: "streams/getLoadingPageState",
      pagesLength: "streams/getPagesLength",
      currentPage: "streams/getCurrentPage",
      userId: "user/getUserId",
      streamInfo: "streams/getStreamInfo",
    }),
    numPages() {
      let extraPage = this.existExtraBlock ? 1 : 0;
      return this.pagesLength + extraPage;
    },
    sizeButton() {
      return this.isTablet ? "sm" : "md";
    },
    isLastPage() {
      return this.currentPage === this.numPages;
    },
    showExtraPage() {
      return this.existExtraBlock && this.isLastPage;
    },
    blockId() {
      return this.currentPage <= this.pagesLength && this.blocks(this.currentPage).length > 0
        ? this.blocks(this.currentPage)[0].id
        : null;
    },
    parsTracking() {
      return {
        streamId: this.$route.params.id,
        aleId: this.$route.params.aleId,
        miuId: Number(this.$route.params.elementId),
        currentPage: this.currentPage,
        blockId: this.blockId ? this.blockId : "extra",
      };
    },
  },
  watch: {
    currentPage: function (val) {
      this.updateRoute(val);
    },
  },
  mixins: [navMixin, mobileCheckMixin, streamMixin],
};
</script>

<style scoped lang="scss">
::v-deep .evaluation-container {
  width: 100%;
}

.progress-bar {
  background-color: $color-white;
  bottom: 0;
  left: 0;
}
.index {
  z-index: 999;
}

.fade-enter,
.fade-enter-active,
.fade-leave,
.fade-leave-active,
.fade-leave-to {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.position-inherit {
  position: inherit;
}
</style>
